import { InteractionRequiredAuthError } from "@azure/msal-browser";
import msalInstance from "../../../auth/msal";
import { AUTH_SCOPES } from "../../../constants/auth";

// Get a valid access token silently - if expired, triggers redirect to Azure AD
export const getAccessToken = async (scopes = AUTH_SCOPES.USER_READ) => {
  const account = msalInstance.getActiveAccount();

  if (!account) {
    throw new Error("No active account. User must login first.");
  }

  try {
    const response = await msalInstance.acquireTokenSilent({
      scopes,
      account,
    });
    return response.accessToken;
  } catch (error) {
    // If silent token acquisition fails, redirect to Azure AD login
    if (error instanceof InteractionRequiredAuthError) {
      await msalInstance.acquireTokenRedirect({ scopes });
    }
    throw error;
  }
};

// Get API access token specifically for calling the C# backend
export const getApiToken = async () => {
  return await getAccessToken(AUTH_SCOPES.API_ACCESS);
};